export const partnerImageDimensions = {
  width: 226,
  height: 97,
};
